/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { isTrue } from "utils/empty-exists";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/pro-solid-svg-icons";

const TextStyleLink = (props) => {
    
    const { link, style } = props;
    const isExternal = isTrue(link?.is_external);
    
    return (
        <>
            <a
                href={link?.url}
                className={`displayLink ${style} `}
                target={link?.is_external ? "_blank" : "_self"}
                rel='noreferrer'
            >
                {link.text}
                {/*{isExternal &&*/}
                {/*    <SVGIcons.fields.LinkField />*/}
                {/*}*/}
            </a>
            {isExternal &&
                <span className='simplicity-link-icon'>&nbsp;<FontAwesomeIcon icon={faArrowUpRightFromSquare} size='1x' /></span>
            }
        </>
    );
};

export { TextStyleLink };
